import { Vue, Component, Ref, Prop, Emit, Inject } from 'vue-property-decorator'
import { formatVariable, checkVariableRegExp, checkVariablesRegExp } from '@/modules/configurationModule/detail/templates/text-templates/shared/models/text-templates.models'
import TextTemplatesModalBasicFormVariablesArea from '@/modules/configurationModule/detail/templates/text-templates/components/text-templates-modal-basic-form-variables-area/text-templates-modal-basic-form-variables-area.vue'
import { every, extend, includes, keys, omit, uniq } from 'lodash'
import { VariableToEmit } from '@/modules/configurationModule/detail/templates/text-templates/components/text-templates-modal-basic-form-variables-area/text-templates-modal-basic-form-variables-area.models'
import { ConfigurationTextTemplateResponse, VariablesAndOptions } from '@/modules/configurationModule/detail/templates/text-templates/services/text-templates.dto'
@Component({
    components: {
        TextTemplatesModalBasicFormVariablesArea
    }
})
export default class TextTemplatesModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly selectedRow!: ConfigurationTextTemplateResponse
    @Ref() readonly textTemplatesRichEditor!: any
    @Inject() externalValidator!: any
    @Emit()
    updateTemplate(template: ConfigurationTextTemplateResponse) {
        return template
    }
    @Emit()
    createTemplate(template: ConfigurationTextTemplateResponse) {
        return template
    }
    constructor() {
        super()
        this.$validator = this.externalValidator
    }

    get canUpdateOrCreate(): boolean {
        return this.$_someFieldIsDirty(this.fields)
    }

    get modelValidated(): boolean {
        const existsDescription = !!this.selectedRow.text.length
        const hasErrors = !!this.errors.count()
        return existsDescription && this.canUpdateOrCreate && !hasErrors && !this.checkIfDuplicatesVariablesWriting() && this.checkDescriptionContainAllVariables()
    }

    createVariable(createVariable: {}): void {
        this.selectedRow.variablesAndOptions = extend({}, this.selectedRow.variablesAndOptions, createVariable)
    }

    updateVariable(updateVariable: VariableToEmit): void {
        this.selectedRow.variablesAndOptions = this.updateKeyVariable(updateVariable)
        this.selectedRow.text = this.replaceTextVariable(updateVariable.oldKey, `${formatVariable(updateVariable.newKey)}`)
    }

    deleteVariable(deletedVariable: string): void {
        this.selectedRow.variablesAndOptions = omit(this.selectedRow.variablesAndOptions, [deletedVariable])
        this.selectedRow.text = this.replaceTextVariable(deletedVariable)
    }

    replaceTextVariable(replaceVariable: string, newValue: string = ''): string {
        const regExp = new RegExp(checkVariableRegExp(replaceVariable), 'g')
        return this.selectedRow.text.replace(regExp, newValue)
    }

    updateText(newText: any): void {
        this.selectedRow.text = newText
        if (this.checkIfDuplicatesVariablesWriting()) {
            this.showDuplicateModalAdvice()
        }
    }

    addTextToDescription(addVariableToDescription: string) {
        const textVariable = `${formatVariable(addVariableToDescription)}`
        const selection = this.textTemplatesRichEditor.$refs.quill.quill.getSelection(true)
        if (this.checkVariableIsDuplicate(addVariableToDescription)) {
            this.showDuplicateModalAdvice()
            return
        }
        this.textTemplatesRichEditor.$refs.quill.quill.insertText(selection?.index, textVariable)
    }

    showDuplicateModalAdvice(): void {
        const labelConfirmation:string = this.$t('configuration.modal.textTemplate.warningDuplicateVariableInDescription')?.toString()
        this.$_showErrorModal(`${labelConfirmation}`)
    }

    checkVariableIsDuplicate(variable: string): boolean {
        const variablesRegExpFound = this.getValuesFromVariableInDescription()
        return !!includes(variablesRegExpFound, variable)
    }

    getValuesFromVariableInDescription(): string[] {
        const matchedVariables: (RegExpMatchArray | null) = this.selectedRow.text.match(checkVariablesRegExp) || []
        return matchedVariables?.map((variableFound: any) => {
            return variableFound.replace(/{|}/g, '').trim()
        })
    }

    checkIfDuplicatesVariablesWriting(): boolean {
        const variablesRegExpFound = this.getValuesFromVariableInDescription()
        return variablesRegExpFound?.length !== uniq(variablesRegExpFound).length && !!variablesRegExpFound?.length
    }

    async showModalAdviceWhenUpdate(): Promise<boolean> {
        const labelConfirmation:string = this.$t('configuration.modal.textTemplate.updateModalConfirmationVariablesText')?.toString()
        const labelDeleteQuestion:string = this.$t('configuration.grid.deleteQuestion')?.toString()
        const labelCancelAction: string = this.$t('component.modalConfirmation.okTitle')?.toString()
        const labelAcceptAction:string = this.$t('component.modalConfirmation.cancelTitle')?.toString()
        return this.$_showConfirmationModal(
            `${labelConfirmation}, ${labelDeleteQuestion}`,
            labelCancelAction,
            labelAcceptAction
        )
    }

    async update(): Promise<void> {
        if (this.selectedRow.id) {
            const promise = await this.showModalAdviceWhenUpdate()
            if (promise) {
                this.updateTemplate(this.selectedRow)
            }
        } else {
            this.createTemplate(this.selectedRow)
        }
    }

    updateKeyVariable(updateVariable: VariableToEmit): VariablesAndOptions {
        let newWordsObject = {}

        Object.keys(this.selectedRow.variablesAndOptions).forEach(key => {
            if (key === updateVariable?.oldKey) {
                newWordsObject = { ...newWordsObject, ...updateVariable.value }
            } else {
                newWordsObject = { ...newWordsObject, [key]: this.selectedRow.variablesAndOptions[key] }
            }
        })
        return newWordsObject
    }

    checkDescriptionContainAllVariables(): boolean {
        const getKeysVariables = keys(this.selectedRow.variablesAndOptions)
        const variablesRegExpFound = this.getValuesFromVariableInDescription()
        const allVariablesDescriptionAreInVariables = this.checkIncludesVariablesValues(variablesRegExpFound, getKeysVariables)
        const allVariablesAreInDescription = this.checkIncludesVariablesValues(getKeysVariables, variablesRegExpFound)
        return allVariablesDescriptionAreInVariables && allVariablesAreInDescription
    }

    checkIncludesVariablesValues(base:string[], aux:string[]): boolean {
        return every(base, (variable:string) => includes(aux, variable))
    }
}
